export default __webpack_public_path__ + "static/media/AppleSDGothicNeoL.4b18037d.woff";